var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"diy-sidebar",class:_vm.sidebarStatus},[(_vm.userType === 'EMPLOYEE')?_c('TheSidebarMenuTeam'):_vm._e(),(_vm.userType === 'CLIENT')?_c('TheSidebarMenuClient'):_vm._e(),(!_vm.isMobile)?_c('AppButtonIcon',{staticClass:"toggle-sidebar",attrs:{"icon":_vm.setIcon},on:{"click":_vm.toggleSidebar}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }